/* Altarus Beauty — product quick view.
 *
 * Product links open the design preview's product dialog instead of navigating.
 * The dialog's panels are read out of the product description, which is already
 * structured: the pearl "Key ingredients" panel supplies the friendly ingredient
 * names (never the INCI list), and the "Why people buy" / "How to use" headings
 * supply the other two. A kit has no ingredient panel of its own, so its list is
 * gathered from the products it links to and shown per product.
 */
(function(){
  var dialog = document.getElementById('ab-qv');
  if (!dialog) return;
  var els = {
    photo:  dialog.querySelector('[data-qv-photo]'),
    thumbs: dialog.querySelector('[data-qv-thumbs]'),
    kind:   dialog.querySelector('[data-qv-kind]'),
    title:  dialog.querySelector('[data-qv-title]'),
    price:  dialog.querySelector('[data-qv-price]'),
    desc:   dialog.querySelector('[data-qv-desc]'),
    kit:    dialog.querySelector('[data-qv-kit]'),
    plans:  dialog.querySelector('[data-qv-plans]'),
    qty:    dialog.querySelector('[data-qv-qty]'),
    add:    dialog.querySelector('[data-qv-add]'),
    acc:    dialog.querySelector('[data-qv-accordions]'),
    link:   dialog.querySelector('[data-qv-link]')
  };

  var current = null, qty = 1, cache = {}, plan = null;

  function money(cents){
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function parse(html){
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return d;
  }
  /* The shipping banner and the "... details · ... details" link row close out a
     description; neither belongs inside a panel. */
  function isBanner(n){
    var style = n.getAttribute && n.getAttribute('style') || '';
    return n.tagName === 'P' && /background/i.test(style);
  }
  function isLinkRow(n){
    if (n.tagName !== 'P') return false;
    var links = n.querySelectorAll('a');
    if (!links.length) return false;
    var linkText = '';
    for (var i = 0; i < links.length; i++) linkText += links[i].textContent;
    return n.textContent.replace(/[^a-z0-9]/gi, '').length <= linkText.replace(/[^a-z0-9]/gi, '').length + 2;
  }
  function headingMatching(doc, res){
    var hs = doc.querySelectorAll('h1,h2,h3,h4');
    for (var i = 0; i < hs.length; i++) {
      for (var r = 0; r < res.length; r++) {
        if (res[r].test(hs[i].textContent)) return hs[i];
      }
    }
    return null;
  }
  /* Everything between a heading and the next heading of the same or higher rank. */
  function sectionAfter(h, stopAtDiv){
    if (!h) return '';
    var out = '', n = h.nextElementSibling;
    var rank = Number(h.tagName.slice(1));
    while (n) {
      if (/^H[1-6]$/.test(n.tagName) && Number(n.tagName.slice(1)) <= rank) break;
      if (isBanner(n) || isLinkRow(n)) break;
      if (stopAtDiv && n.tagName === 'DIV') break;
      out += n.outerHTML;
      n = n.nextElementSibling;
    }
    return out;
  }
  function pillsList(doc){
    var pills = doc.querySelectorAll('span[style*="FFD400" i]');
    if (!pills.length) return '';
    var items = [];
    for (var i = 0; i < pills.length; i++) items.push('<li>' + pills[i].textContent.trim() + '</li>');
    return '<ul>' + items.join('') + '</ul>';
  }
  function leadParagraph(doc){
    var p = doc.querySelector('p');
    return p ? p.innerHTML : '';
  }
  /* Only a genuine "Key ingredients" panel counts. The kits use the same styled
     box for their price snapshot, which is not an ingredient list. */
  function keyIngredients(doc){
    var boxes = doc.querySelectorAll('div[style*="FFFBEA" i]');
    for (var b = 0; b < boxes.length; b++) {
      var head = boxes[b].querySelector('h1,h2,h3,h4,strong');
      if (!head || !/key ingredients/i.test(head.textContent)) continue;
      var clone = boxes[b].cloneNode(true);
      var h = clone.querySelector('h1,h2,h3,h4');
      if (h) h.remove();
      return clone.innerHTML;
    }
    var heading = headingMatching(doc, [/key ingredients/i, /^\s*ingredients\s*$/i]);
    return sectionAfter(heading, true);
  }
  /* The products a kit is built from, in the order the description lists them. */
  function componentHandles(doc, own){
    var links = doc.querySelectorAll('a[href*="/products/"]');
    var out = [], seen = {};
    for (var i = 0; i < links.length; i++) {
      var m = (links[i].getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) continue;
      var h = m[1];
      if (h === own || seen[h]) continue;
      seen[h] = true;
      out.push(h);
    }
    return out.slice(0, 6);
  }

  /* The design preview shows a kit as a small pearl panel — a label and the
     product names, nothing else. The description keeps them in a priced table,
     so the names are lifted out of it and the panel rebuilt in that shape. */
  function kitList(html){
    if (!html) return '';
    var rows = parse(html).querySelectorAll('tr');
    var items = [];
    for (var i = 0; i < rows.length; i++) {
      var cell = rows[i].querySelector('td');
      if (!cell) continue;
      var name = cell.querySelector('strong');
      var title = (name ? name.textContent : cell.textContent).replace(/^\s*\d+[.)]\s*/, '').trim();
      if (title) items.push('<li>' + esc(title) + '</li>');
    }
    if (!items.length) return html;
    var label = items.length === 3 ? 'Your three-step set' : 'What is inside';
    return '<h3>' + label + '</h3><ul>' + items.join('') + '</ul>';
  }

  function build(product){
    var doc = parse(product.description);
    var ingredients = keyIngredients(doc);

    var whyHeading = headingMatching(doc, [/why people buy/i, /why you.?ll reach for it/i]);
    var why = sectionAfter(whyHeading);
    if (!why) {
      var lead = leadParagraph(doc), pills = pillsList(doc);
      if (lead || pills) why = (lead ? '<p>' + lead + '</p>' : '') + pills;
    }

    var howHeading = headingMatching(doc, [/how to use/i, /^\s*care\s*$/i]);
    var how = sectionAfter(howHeading);

    var insideHeading = headingMatching(doc, [/what is inside/i, /what.s inside/i]);
    var inside = sectionAfter(insideHeading, true);

    return {
      ingredients: ingredients,
      why: why,
      how: how,
      inside: inside,
      lead: leadParagraph(doc),
      components: ingredients ? [] : componentHandles(doc, product.handle)
    };
  }

  /* Every panel starts closed. A kit re-renders once its ingredient lists
     arrive, so anything the reader opened in the meantime is reopened. */
  function renderAccordions(parts, pending){
    var opened = {};
    var existing = els.acc.querySelectorAll('details[open] summary');
    for (var e = 0; e < existing.length; e++) opened[existing[e].textContent] = true;
    var rows = [
      ['Full ingredients', parts.ingredients || (pending ? '<p>Gathering the ingredient lists…</p>' : '')],
      ['Why people buy', parts.why],
      ['How to use', parts.how]
    ].filter(function(r){ return r[1] && r[1].trim(); });
    els.acc.innerHTML = rows.map(function(r){
      return '<details' + (opened[r[0]] ? ' open' : '') + '><summary>' + r[0] + '</summary><div class="qv-acc-body">' + r[1] + '</div></details>';
    }).join('');
    els.acc.hidden = rows.length === 0;
  }

  /* A kit's ingredient list is the friendly lists of the products inside it,
     kept under each product's name so it stays readable. */
  function loadComponentIngredients(product, parts){
    var handle = product.handle;
    Promise.all(parts.components.map(function(h){
      if (cache[h]) return Promise.resolve(cache[h]);
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){ if (p) cache[h] = p; return p; })
        .catch(function(){ return null; });
    })).then(function(list){
      if (!current || current.handle !== handle) return;
      var html = '';
      list.forEach(function(p){
        if (!p) return;
        var box = keyIngredients(parse(p.description));
        if (!box || !box.trim()) return;
        html += '<p class="qv-acc-sub">' + esc(p.title) + '</p>' + box;
      });
      parts.ingredients = html;
      renderAccordions(parts, false);
    });
  }

  /* One row per purchase option: the one-time price, then each subscription
     frequency Recharge publishes for the product. */
  function frequencyLabel(value){
    var m = String(value).match(/^(\d+)[-\s]*(day|week|month|year)/i);
    if (!m) return value;
    var n = Number(m[1]), unit = m[2].toLowerCase();
    return n === 1 ? 'Every ' + unit : 'Every ' + n + ' ' + unit + 's';
  }
  function planOptions(product, variant){
    var prices = {};
    (variant && variant.selling_plan_allocations || []).forEach(function(a){
      prices[a.selling_plan_id] = a.price;
    });
    var out = [];
    (product.selling_plan_groups || []).forEach(function(group){
      var freq = '';
      (group.options || []).forEach(function(o){
        if (/frequency/i.test(o.name) && o.values && o.values.length) freq = o.values[0];
      });
      (group.selling_plans || []).forEach(function(p){
        out.push({ id: p.id, label: freq ? frequencyLabel(freq) : p.name, price: prices[p.id] });
      });
    });
    return out.filter(function(p){ return typeof p.price === 'number'; });
  }

  function renderPlans(product, variant){
    plan = null;
    var options = planOptions(product, variant);
    if (!options.length || !variant) {
      els.plans.innerHTML = '';
      els.plans.hidden = true;
      return;
    }
    var base = variant.price;
    var best = options.reduce(function(a, b){ return b.price < a.price ? b : a; });
    var save = base > best.price ? Math.round((1 - best.price / base) * 100) : 0;
    var oneTime = !product.requires_selling_plan;
    plan = oneTime ? null : options[0].id;

    var rows = '';
    if (oneTime) {
      rows += '<label class="qv-plan is-selected">' +
        '<input type="radio" name="qv-plan" value="" checked>' +
        '<span class="qv-plan-main"><span class="qv-plan-name">One-time purchase</span></span>' +
        '<span class="qv-plan-price">' + money(base) + '</span></label>';
    }
    var select = options.length > 1
      ? '<select class="qv-plan-freq" data-qv-freq aria-label="Delivery frequency">' + options.map(function(o, i){
          return '<option value="' + o.id + '"' + (i === 0 ? ' selected' : '') + '>' + esc(o.label) + '</option>';
        }).join('') + '</select>'
      : '<span class="qv-plan-sub">' + esc(options[0].label) + '</span>';
    rows += '<label class="qv-plan' + (oneTime ? '' : ' is-selected') + '">' +
      '<input type="radio" name="qv-plan" value="' + options[0].id + '"' + (oneTime ? '' : ' checked') + '>' +
      '<span class="qv-plan-main"><span class="qv-plan-name">Subscribe &amp; save' +
      (save ? '<span class="qv-plan-save">' + save + '% off</span>' : '') + '</span>' + select + '</span>' +
      '<span class="qv-plan-price">' + (base > best.price ? '<s>' + money(base) + '</s>' : '') + money(best.price) + '</span></label>';

    els.plans.innerHTML = rows;
    els.plans.hidden = false;
  }

  function selectPlan(input){
    var labels = els.plans.querySelectorAll('.qv-plan');
    for (var i = 0; i < labels.length; i++) {
      labels[i].classList.toggle('is-selected', labels[i].contains(input));
    }
    plan = input.value ? Number(input.value) : null;
  }

  function setPhoto(src, index){
    els.photo.src = src;
    var btns = els.thumbs.querySelectorAll('button');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', String(i === index));
    }
  }

  function render(product){
    current = product;
    qty = 1;
    els.qty.textContent = '1';
    els.kind.textContent = product.type || '';
    els.kind.hidden = !product.type;
    els.title.textContent = product.title;
    els.price.innerHTML = (product.compare_at_price && product.compare_at_price > product.price)
      ? '<s>' + money(product.compare_at_price) + '</s> ' + money(product.price)
      : money(product.price);
    els.link.href = product.url;

    els.acc.innerHTML = '';
    var parts = build(product);
    els.desc.innerHTML = parts.lead ? '<p>' + parts.lead + '</p>' : '';
    els.kit.innerHTML = kitList(parts.inside);
    els.kit.hidden = !parts.inside;
    renderAccordions(parts, parts.components.length > 0);
    if (parts.components.length) loadComponentIngredients(product, parts);

    var images = product.images || [];
    els.thumbs.innerHTML = images.length > 1 ? images.map(function(src, i){
      return '<button type="button" class="qv-thumb" data-qv-thumb="' + i + '" aria-pressed="' + (i === 0) +
             '" aria-label="Show image ' + (i + 1) + '"><img src="' + src + '" alt="" loading="lazy"></button>';
    }).join('') : '';
    els.thumbs.hidden = images.length < 2;
    els.photo.alt = product.title;
    setPhoto(images[0] || product.featured_image, 0);

    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) { variant = product.variants[i]; break; }
    }
    renderPlans(product, variant);
    els.add.dataset.variant = variant ? variant.id : '';
    els.add.disabled = !variant;
    els.add.textContent = variant ? 'Add to bag' : 'Sold out';
  }

  function open(handle){
    var show = function(p){
      render(p);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      dialog.scrollTop = 0;
    };
    if (cache[handle]) return show(cache[handle]);
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(p){ cache[handle] = p; show(p); })
      .catch(function(){ window.location.href = '/products/' + handle; });
  }

  function close(){
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function addToBag(button){
    if (!button.dataset.variant) return;
    button.disabled = true;
    var item = { id: Number(button.dataset.variant), quantity: qty };
    if (plan) item.selling_plan = plan;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(){
        close();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'ab-quick-view' } }));
        var opener = document.querySelector('[aria-controls="cart-drawer"], [data-cart-drawer-opener]');
        if (opener && opener.tagName === 'BUTTON') opener.click();
        button.disabled = false;
      })
      .catch(function(){ button.disabled = false; window.location.href = '/cart'; });
  }

  dialog.addEventListener('change', function(e){
    var t = e.target;
    if (t.name === 'qv-plan') return selectPlan(t);
    if (t.hasAttribute && t.hasAttribute('data-qv-freq')) {
      var row = t.closest('.qv-plan');
      var radio = row && row.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.value = t.value;
      radio.checked = true;
      selectPlan(radio);
    }
  });

  dialog.addEventListener('click', function(e){
    if (e.target === dialog) return close();
    var el = e.target.closest('button');
    if (!el) return;
    if (el.hasAttribute('data-qv-close')) return close();
    if (el.hasAttribute('data-qv-thumb')) {
      var i = Number(el.getAttribute('data-qv-thumb'));
      return setPhoto(current.images[i], i);
    }
    if (el.hasAttribute('data-qv-minus')) { qty = Math.max(1, qty - 1); els.qty.textContent = qty; return; }
    if (el.hasAttribute('data-qv-plus'))  { qty = qty + 1; els.qty.textContent = qty; return; }
    if (el.hasAttribute('data-qv-add'))   { return addToBag(el); }
  });

  /* Product links open the popup. Modified clicks, links marked
     data-no-quickview, and the page you are already on still behave normally,
     so every product URL keeps working on its own. */
  document.addEventListener('click', function(e){
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var a = e.target.closest('a[href]');
    if (!a || a.hasAttribute('data-no-quickview') || a.target === '_blank') return;
    var url;
    try { url = new URL(a.href, window.location.origin); } catch (err) { return; }
    if (url.origin !== window.location.origin) return;
    var m = url.pathname.match(/^\/products\/([^\/?#]+)$/);
    if (!m) return;
    if (window.location.pathname === url.pathname) return;
    e.preventDefault();
    open(m[1]);
  });
})();